<template>
	<el-container>
		<!-- 头部区域 -->
		<el-header class="fixed-header">
			<Header />
		</el-header>
		<!-- 主要内容区域 -->
		<el-main class="main-content">
			<router-view />
		</el-main>
	</el-container>
</template>

<script setup>
	import Header from "../../components/Header.vue";
</script>

<style lang="less" scoped>
	.fixed-header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 60px; /* 固定高度，和 line-height 保持一致 */
		background-color: #1b1c1e;
		color: #ffffff;
		text-align: center;
		line-height: 60px;
		z-index: 1000; /* 保证头部在最上层 */
	}

	.main-content {
		margin-top: 60px; /* 给主体内容留出头部高度的空间，避免被遮挡 */
		background-color: #ffffff;
		color: #333;
		text-align: center;
		padding: 0;
	}
</style>
